import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import styles from './CategorySelect.module.scss';
const CategorySelect = ({ options, label = 'Select', selected, onChange, id, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);
    const firstOptionRef = useRef(null);
    const toggleOpen = () => setIsOpen(!isOpen);
    const handleSelect = (option) => {
        var _a;
        if (onChange)
            onChange(option);
        setIsOpen(false);
        (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (selectRef.current && !selectRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);
    useEffect(() => {
        if (isOpen && firstOptionRef.current) {
            firstOptionRef.current.focus();
        }
    });
    const keyDownHandler = (e) => {
        var _a;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleOpen();
        }
        if (e.key === 'Escape') {
            setIsOpen(false);
            (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    const optionKeyDownHandler = (e, option) => {
        var _a;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleSelect(option);
            (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    return (_jsxs("div", Object.assign({ className: styles.select, id: id, onKeyDown: keyDownHandler, "data-testid": "category-select-component" }, { children: [_jsxs("div", Object.assign({ className: `${styles.select__trigger} ${isOpen ? styles.open : ''}`, onClick: toggleOpen, tabIndex: 0, ref: selectRef, "data-testid": "category-select-trigger" }, { children: [_jsx("span", { children: selected || label }), _jsx("div", { className: styles.select__arrow })] })), isOpen && (_jsx("ul", Object.assign({ className: styles.select__options, "data-testid": "category-options" }, { children: options.map((opt, index) => (_jsx("li", Object.assign({ className: `${styles.select__option} ${opt === selected ? styles.active : ''}`, onClick: () => handleSelect(opt), tabIndex: 0, onKeyDown: (e) => optionKeyDownHandler(e, opt), ref: index === 0 ? firstOptionRef : null }, { children: opt }), opt))) })))] })));
};
export default CategorySelect;
